module.exports = __webpack_public_path__ + "static/media/p20.48d8f61d.png";